import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import useTransportationOrderService from '../../../app/services/hooks/useTransportationOrderService';
import useOrderService from '../../../app/services/hooks/useOrderService';
import {
    defaultTransportationOrderDataForm,
    defaultTransportationOrderRateDataForm,
    TransportationOrderDataForm,
    TransportationOrderRatesDataForm
} from '../../../app/models/TransportationOrder';
import DefaultCard from '../../../components/default/DefaultCard';
import LazyLoading from '../../../components/LazyLoading';
import DefaultCreatedModifiedUserForm from '../../../components/default/DefaultCreatedModifiedUserForm';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import TransportationOrderShowForm from '../components/forms/TransportationOrderShowForm';
import TransportationOrderItemsContainer from '../components/TransportationOrderItemsContainer';
import { TransportationQuoteDetail } from '../../../app/models/TransportationQuoteDetail';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import TransportationOrderRatesForm from '../components/forms/TransportationOrderRatesForm';
import TransportationOrderRatesShow from '../components/TransportationOrderRatesShow';
import { Tab, Tabs } from 'react-bootstrap';
import TransportationOrderInvoicingShowForm from '../components/forms/TransportationOrderInvoicingForm';
import { TransportationOrderInvoicingShowDataForm } from '../../../app/models/TransportationOrderInvoicing';
import useQuoteInvoicingService from '../../../app/services/hooks/useQuoteInvoicingService';

type RouterParams = {
    id: string;
};

const TransportationOrderShow = () => {
    const { id } = useParams<RouterParams>();
    const location = useLocation();
    const isUnifiedMode = location.pathname.startsWith('/pedidos/');

    const [errorFields, setErrorFields] = useState<any>();
    const { showTransportationOrder, fetchingShowTransportationOrder } =
        useTransportationOrderService();
    const { showUnifiedOrder, fetchingShowOrder } = useOrderService();
    const isLoadingShow = isUnifiedMode ? fetchingShowOrder : fetchingShowTransportationOrder;
    const [quotes, setQuotes] = useState<TransportationQuoteDetail[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);
    const [transportationOrderInvoicingForm, setTransportationOrderInvoicingInvoicingForm] = useState<TransportationOrderInvoicingShowDataForm>({});
    const { 
        editQuoteInvoicing,
        getQuoteInvoicingByQuote,
        updateQuoteInvoicing, 
        fetchingQuoteInvoicingByQuote,
        fetchingUpdateQuoteInvoicing
    } = useQuoteInvoicingService();

    const [transportationOrderForm, setTransportationOrderForm] =
        useState<TransportationOrderDataForm>(defaultTransportationOrderDataForm);
    const [orderId, setOrderId] = useState<number | undefined>(undefined);

    const [transportationOrderRatesForm, setTransportationOrderRatesForm] =
        useState<TransportationOrderRatesDataForm>(defaultTransportationOrderRateDataForm);

    useEffect(() => {
        show(parseInt(id));
    }, [id]);

    const show = (id: number) => {
        const showFn = isUnifiedMode ? showUnifiedOrder : showTransportationOrder;
        showFn(id, {
            onSuccess: (response: ServiceResponse) => {
                setTransportationOrderForm(response.data.transportation_order);
                setTransportationOrderRatesForm(response.data.transportation_order);
                setQuotes(response.data.quotes);
                setTransportationOrderInvoicingInvoicingForm(response.data.invoicing);
                if (response.data.order_id) setOrderId(response.data.order_id);
            }
        });
    };

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Pedidos',
            url: '/pedidos',
            isActive: false
        },
        {
            name: 'Ver pedido #' + id,
            url: (isUnifiedMode ? '/pedidos/' : '/transportation-orders/') + id + '/show',
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Ver pedido #${id}`} breadcrumbs={breadcrumbs} />
               <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                    <Tab eventKey="general-data" title="Datos Generales">
            <div className="row">
                <div className="col-md-6">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Datos Generales</div>
                        {!isLoadingShow ? (
                            <>
                                <TransportationOrderShowForm
                                    transportationOrderDataForm={transportationOrderForm}
                                    quotes={quotes}
                                />
                                {/*<TransportationOrderRatesShow*/}
                                {/*    transportationOrderRatesForm={transportationOrderRatesForm}*/}
                                {/*/>*/}
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </div>
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="h3 mt-0 mb-2 card-title">Usuarios</div>
                            {!isLoadingShow ? (
                                <DefaultCreatedModifiedUserForm
                                    createdBy={transportationOrderForm.created_user}
                                    createdAt={transportationOrderForm.created_at}
                                    updatedBy={transportationOrderForm.last_modified_user}
                                    updatedAt={transportationOrderForm.updated_at}
                                    status={transportationOrderForm.status}
                                    // status={
                                    //     transportationOrderForm.status_selected
                                    //         ? transportationOrderForm.status_selected.name.toString()
                                    //         : ''
                                    // }
                                />
                            ) : (
                                <LazyLoading />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            </Tab>

            <Tab eventKey="invoicing" title="Facturación">
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">Facturación</div>
                                <>
                                    <TransportationOrderInvoicingShowForm
                                        transportationOrderInvoicingDataForm={transportationOrderInvoicingForm}
                                        setTransportationOrderInvoicingDataForm={setTransportationOrderInvoicingInvoicingForm}
                                        // currencies={currencies}
                                        // references={references}
                                        // paymentMethods={paymentMethods}
                                        // paymentConditions={paymentConditions}
                                        // exchangeRateSource={exchangeRateDateSource}
                                        errorFields={errorFields}
                                    />
                                </>
                        </DefaultCard>
            </Tab>
            </Tabs>

            <TransportationOrderItemsContainer
                transportationOrderId={parseInt(id)}
                orderId={orderId}
                canBeEdited={false}
                currencyId={transportationOrderForm.currency_id}
                isShow={true}
                transportationOrderForm={transportationOrderForm}
                setTransportationOrderForm={setTransportationOrderForm}
            />
        </>
    );
};

export default TransportationOrderShow;
